// Shared helper to extract a user-friendly message from axios/FastAPI errors.
// FastAPI returns:
//   - 422: detail is an array of Pydantic validation errors:
//     [{type, loc: ['body', 'field'], msg, input, url}, ...]
//   - 400/404/409: detail is a string or an object with {field, message}
//   - Others: fallback to generic message
//
// Never returns a non-string, so it is safe to pass to toast.error().
export const getApiErrorMessage = (error, fallback = 'An error occurred') => {
  const detail = error?.response?.data?.detail;
  if (detail === undefined || detail === null) return fallback;

  if (typeof detail === 'string') return detail;

  if (Array.isArray(detail)) {
    // Pydantic validation errors
    const parts = detail.map((e) => {
      const msg = (e && typeof e === 'object') ? (e.msg || e.message) : String(e);
      const loc = Array.isArray(e?.loc) ? e.loc : null;
      // Skip 'body' prefix when present
      const field = loc
        ? loc.filter((seg) => seg !== 'body').join('.')
        : '';
      return field ? `${field}: ${msg}` : msg;
    }).filter(Boolean);
    return parts.length ? parts.join('; ') : fallback;
  }

  if (typeof detail === 'object') {
    return detail.message || detail.msg || JSON.stringify(detail);
  }

  return String(detail);
};
